import { createAction, props } from "@ngrx/store";
import { ISkillNode } from "@skills-app/models/skillNode";

const prefix = "[Related Search Skills]";

export const addSkillToSearch = createAction(
  `${prefix} Add Skill To Search`,
  props<{ skill: ISkillNode }>(),
);
